import React, { useEffect, useState } from 'react';
import { TOOLS } from '../mock';
import { api } from '../api';
import { Rocket, BarChart3, Target, Users, Check } from 'lucide-react';

const ICONS = { Rocket, BarChart3, Target, Users };

const Tools = () => {
  const [brandName, setBrandName] = useState('IGGrowth');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await api.getPublicSettings();
        setBrandName(settings?.brand_name || settings?.brandName || 'IGGrowth');
      } catch (error) {
        // Keep the safe fallback if public settings are unavailable.
      }
    };

    loadSettings();
  }, []);

  const replaceBrand = (text) => {
    if (typeof text !== 'string') return text;
    return text.replace(/\{\{brand\}\}/g, brandName);
  };

  return (
    <section id="tools" className="py-24">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm font-bold tracking-widest uppercase plixy-gradient-text">
            Our Tools
          </p>

          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-[#0a1930] leading-tight">
            Patented, Personalized{' '}
            <span className="plixy-gradient-text">
              AI Growth Service
            </span>
          </h2>

          <p className="mt-4 text-lg text-slate-600">
            Everything you need to grow real followers on Instagram &amp; TikTok
            — automated, targeted and safe.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {TOOLS.map((tool) => {
            const Icon = ICONS[tool.icon];

            return (
              <div
                key={tool.id}
                className="group relative rounded-3xl p-8 bg-white border border-slate-200 hover:border-transparent hover:shadow-2xl transition-all duration-300"
              >
                <div
                  className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br ${tool.accent} text-white mb-5 shadow-lg`}
                >
                  <Icon className="w-7 h-7" />
                </div>

                <div className="inline-block text-xs font-bold tracking-widest uppercase text-slate-500 mb-2">
                  {tool.tag}
                </div>

                <h3 className="text-2xl font-extrabold text-[#0a1930] leading-snug">
                  {tool.title}
                </h3>

                <p className="mt-3 text-slate-600">
                  {replaceBrand(tool.desc)}
                </p>

                <ul className="mt-5 space-y-2">
                  {tool.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-center gap-2 text-slate-700"
                    >
                      <span className="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center">
                        <Check
                          className="w-3 h-3 text-emerald-600"
                          strokeWidth={3}
                        />
                      </span>

                      <span className="font-semibold">{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Tools;
